angular.module('impactx.b2b').controller('CustomerConfigurationsListCtrl', [
    'selectedListItems',
    '$mdDialog',
    'ListHelperService',
    '$scope',
    'ConfirmationService',
    '$redirect',
    'ToastService',
    'TranslationService',
    'dataGen',
    CustomerConfigurationsListCtrl
]);

function CustomerConfigurationsListCtrl(selectedListItems, $mdDialog, ListHelperService, $scope,
                                   ConfirmationService, $redirect, ToastService, TranslationService, dataGen) {
    var self = this;

    this.deleteEntry = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedId()}, "/b2b/customerconfiguration/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                ListHelperService.refreshListData($scope, 'customerConfigurationsListCtrl', {unselectRows: selectedItems});
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    this.canDelete = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().deleted;
    }

    this.getDetailLink = function () {
        return "customerconfiguration/" + selectedListItems.getFirstSelectedId();
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCustomerConfigurations'
        },
        {
            label: "delete",
            type: 'dialogaction',
            action: self.deleteEntry,
            condition: self.canDelete,
            process: 'EditCustomerConfigurations'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/b2b/templates/customerconfigurations.row.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/b2b/customerconfigurations/list',
        id: "customerconfigurationslist",
        mainAction: {id: "new", link: "#/customerconfiguration/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };
}
